import { type ReactNode } from "react";
import { type NumberFormatValues } from "react-number-format/types/types";
import { useField } from "formik";

import {
  NumberInput,
  type NumberInputProps,
} from "@vega-core/components/Form/Controls/Input/NumberInput";
import { useTouchFieldOnSubmit } from "@vega-core/helpers/formik.helper";
import { isTruthy } from "@vega-core/utils/isTruthy";

export function NumberField({
  name,
  labelTag,
  ...props
}: Omit<NumberInputProps, "value"> & { labelTag?: ReactNode }) {
  const [numberField, numberMeta, numberHelpers] = useField(name);
  useTouchFieldOnSubmit(name);

  const handleChange = (event: NumberFormatValues) => {
    const value = event.value;
    numberHelpers.setValue(value);
  };

  return (
    <NumberInput
      {...props}
      error={
        numberMeta.touched && isTruthy(numberMeta.error)
          ? numberMeta.error
          : undefined
      }
      labelTag={labelTag}
      name={numberField.name}
      onBlur={() => numberHelpers.setTouched(true)}
      onChange={handleChange}
      value={numberField.value ?? ""}
    />
  );
}
